export default "__VITE_ASSET__18f1ccd4__"